export default "__VITE_ASSET__CLSkAwcY__"